import { jsx } from "react/jsx-runtime";
import "react";
import { cn } from "../../utils/index.js";
import { Span } from "../Text/index.js";
import { highlightVariants } from "./Highlight.variants.js";
function Highlight({ children, className, ...props }) {
    const { highlightSlot, childrenSlot } = highlightVariants(props);
    return /*#__PURE__*/ jsx(Span, {
        className: cn(highlightSlot(), childrenSlot(), props.textStyle ? 'inline-block' : '', className),
        ...props,
        children: children
    });
}
export { Highlight };
